<template>
    <div>
        <div class="columns mb-0">
            <div
                v-if="$meta.features.vendors.asking_price"
                class="column mb-0 pb-0"
            >
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-2">
                        Asking Price
                    </h5>
                    <p>
                        {{ property.dblSalesAskingPrice | currency | withPoundSymbol }}
                    </p>
                </Card>
            </div>
            <div
                v-if="$meta.features.vendors.fee"
                class="column mb-0 pb-0"
            >
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-2">
                        Fee
                    </h5>
                    <p>
                        <span
                            v-if="property.dblSalesFee"
                        >
                            {{ property.dblSalesFee | currency | withPoundSymbol }}
                        </span>
                        <span
                            v-if="property.dblSalesFee && property.dblSalesFeePercentage"
                            class="mx-2"
                        >
                            &#8226;
                        </span>
                        <span
                            v-if="property.dblSalesFeePercentage"
                        >
                            {{ property.dblSalesFeePercentage }}%
                        </span>
                    </p>
                </Card>
            </div>
            <div
                v-if="$meta.features.vendors.sales_status"
                class="column mb-0 pb-0"
            >
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-2">
                        Sales Status
                    </h5>
                    <p>
                        {{ property.strSalesStatus }}
                    </p>
                </Card>
            </div>
            <div
                v-if="$meta.features.vendors.agency_status"
                class="column mb-0 pb-0"
            >
                <Card :styles="['has-text-centered']">
                    <h5 class="title is-5 mb-2">
                        Agency Status
                    </h5>
                    <p>
                        {{ property.strSalesAgencyStatus }}
                    </p>
                </Card>
            </div>
        </div>

        <Card v-if="property.memSalesSummaryDescription">
            <h3>
                Summary description
            </h3>
            {{ property.memSalesSummaryDescription }}
        </Card>

        <Card v-if="property.memSalesMarketingDescription">
            <h3>
                Full description
            </h3>
            {{ property.memSalesMarketingDescription }}
        </Card>

        <hr />

        <PropertyBrochures />

        <hr />

        <PropertyPhotos />
    </div>
</template>


<script>
import PropertyPhotos from '../components/PropertyPhotos.vue';
import PropertyBrochures from '../components/PropertyBrochures.vue';
import Card from '../components/Card.vue';
import { mapState } from 'vuex';

export default {
    components: {
        PropertyPhotos,
        PropertyBrochures,
        Card,
    },

    computed: {
        ...mapState('salesProperty', [
            'property',
        ]),
    },
};
</script>
